<div class="business-logo">
  <div
    *ngIf="!logo || forceAlt"
    class="initial-letter"
    [style.width]="size"
    [style.height]="size"
    [style.font-size]="size"
  >
    <p>{{ alt?.charAt(0) }}</p>
  </div>

  <img
    *ngIf="logo && !forceAlt"
    [src]="logo"
    [style.height]="size"
    (error)="imageLoadError()"
  />
</div>
